import { storage } from './storage';

const STORAGE_KEY = 'alchemy_duel_user_id';

/**
 * Генерирует UUID v4
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Получает или создаёт userId для пользователя.
 */
export function getUserId(): string {
  let userId = storage.getItem(STORAGE_KEY);

  if (!userId) {
    userId = generateUUID();
    storage.setItem(STORAGE_KEY, userId);
  }

  return userId;
}
